import { TopBar } from "@components/TopBar";
import { Suspense } from "react";
import { Navigate, useParams } from "react-router-dom";

export const TEAM_ROUTES = [
  {
    index: true,
    element: <Navigate to="/configuration/messages" replace />,
  },
  {
    path: ":teamId",
    async lazy() {
      const { TeamDetailPage } = await import("./TeamDetailPage");

      return {
        Component() {
          const { teamId } = useParams<{ teamId: string }>();

          return (
            <Suspense fallback={<TopBar title={["Configuration", "Messages"]} />}>
              <TeamDetailPage teamId={teamId!} />
            </Suspense>
          );
        },
      };
    },
  },
];
